import { getWeek, isSameDay } from 'date-fns'
import { InsightTime } from 'zens-store'

export function groupByWeek(items?: InsightTime[]) {
  return items?.reduce((acc, item) => {
    if (
      acc.length > 0 &&
      getWeek(acc[acc.length - 1].date, { weekStartsOn: 1 }) !== getWeek(item.date, { weekStartsOn: 1 })
    )
      acc.push(
        new InsightTime(undefined, {
          x: '',
          y: null,
          ymax: null,
        }),
      )
    acc.push(item)
    return acc
  }, [] as InsightTime[])
}

export function groupByDay(items?: InsightTime[]) {
  return items?.reduce((acc, item) => {
    if (acc.length > 0 && !isSameDay(acc[acc.length - 1].date, item.date))
      acc.push(
        new InsightTime(undefined, {
          x: '',
          y: null,
          ymax: null,
        }),
      )
    acc.push(item)
    return acc
  }, [] as InsightTime[])
}
